<script setup>
</script>
        
<template>
    <h1 class="text-[36px] md:text-[60px] font-bold uppercase mb-10">{{ $t('Sitemap') }}</h1>
</template>